import { useEffect, useMemo, useRef } from 'react';

import { IProps } from './types';

/** При дизейбле всех свойств кроме одного, выбирает оставшееся свойство **/
export const useSelectSingleAvailableValue = ({ source, onChange, enabled = true }: IProps) => {
  const isSingleOptionAvailable = useMemo(() => source?.filter(item => !item.disabled).length === 1, [source]);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (!isSingleOptionAvailable) {
      return;
    }
    const checkedOption = source?.find(item => !item.disabled);
    if (checkedOption) {
      onChangeRef.current(checkedOption.value);
    }
  }, [enabled, isSingleOptionAvailable, source]);
};
